import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'black-about',
    templateUrl: './about.component.html',
    styleUrls: ['./about.component.css'],
    standalone: false
})
export class AboutComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
